<template>
    <comp-9-prep-adherence :section="9" :page="23" :nextDisabled="nextDisabled">
        <p>
            OK, so you’ve got commitment, which is key! Now let’s identify all the reasons that can help you stay committed.
        </p>
        <p>
            Below is a list of different reasons why folks go on PrEP. Place a checkmark next to any items below that reflect why you’re on PrEP. Feel free to
            add any reasons that may not be there.
        </p>
        <v-checkbox
            v-for="motivation in prepMotivations"
            :key="motivation.id"
            :label="motivation.text"
            :value="motivation.id"
            v-model="selectedMotivations"
            hide-details
            dense
        ></v-checkbox>
        <v-text-field v-if="showManualResponse" outline single-line type="text" v-model.trim="selectedMotivationResponse"></v-text-field>
    </comp-9-prep-adherence>
</template>

<script>
import { sync } from 'vuex-pathify';
import { filter, map, forEach } from 'lodash';

export default {
    data: function() {
        return {
            selectedMotivations: [],
            selectedMotivationResponse: null
        };
    },
    computed: {
        prepSelectedMotivations() {
            let prepSelectedMotivations = map(filter(this.prepMotivations, 'selected'), 'id');

            if (prepSelectedMotivations) {
                return prepSelectedMotivations;
            } else return [];
        },
        prepSelectedMotivationsResponse() {
            let userEnteredMotivation = filter(filter(this.prepMotivations, 'selected'), 'userEntered');

            if (userEnteredMotivation.length > 0) {
                return userEnteredMotivation[0].response;
            }

            return null;
        },
        showManualResponse() {
            if (filter(filter(this.prepMotivations, 'selected'), 'userEntered').length > 0) {
                return true;
            }

            return false;
        },
        prepMotivations: sync('section9/prepMotivators')
    },
    methods: {
        nextDisabled() {
            if (this.selectedMotivations.length === 0 || (this.showManualResponse && !this.selectedMotivationResponse)) {
                return true;
            } else {
                return false;
            }
        }
    },
    watch: {
        selectedMotivations() {
            forEach(this.prepMotivations, o => {
                if (this.selectedMotivations.includes(o.id)) {
                    o.selected = true;

                    if (o.userEntered) {
                        o.response = this.selectedMotivationResponse;
                    }
                } else {
                    o.selected = false;

                    if (o.userEntered) {
                        o.response = null;
                    }
                }
            });
        },
        selectedMotivationResponse() {
            forEach(this.prepMotivations, o => {
                if (o.userEntered && o.selected) {
                    o.response = this.selectedMotivationResponse;
                }
            });
        }
    },
    mounted() {
        this.selectedMotivations = this.prepSelectedMotivations;
        this.selectedMotivationResponse = this.prepSelectedMotivationsResponse;
    }
};
</script>
